module.exports = __webpack_public_path__ + "img/wave-gray-dark.28203b31.png";